import { render, staticRenderFns } from "./recordingDetails.vue?vue&type=template&id=0a6070ec&scoped=true&"
import script from "./recordingDetails.vue?vue&type=script&lang=js&"
export * from "./recordingDetails.vue?vue&type=script&lang=js&"
import style0 from "./recordingDetails.vue?vue&type=style&index=0&id=0a6070ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6070ec",
  null
  
)

export default component.exports